<template>
  <div class="form-payment">
    <div class="plan-details-shop w-100">
      <TextBlock
        tag="div"
        class="mb-4 shop-white-tekst"
        style="color: rgba(255, 255, 255, 1); font-size: 1.5rem !important"
      >
        {{ $t(`_web_checkout_shop-payment`, 'Payment') }}
      </TextBlock>
      <div class="divider-payment-sub"></div>
      <div v-if="isPriceLoading" class="block-loading" />
      <div v-if="price.details" class="plan-details subscription-details w-100">
        <div class="name-amount d-flex justify-content-between mb-3">
          <div>
            <TextBlock class="shop-grey-tekst mb-2">
              {{ plan.name }}
            </TextBlock>
          </div>
          <div class="price">
            <TextBlock class="shop-white-tekst">{{
              $$t(price.currency)
            }}</TextBlock>
            <TextBlock class="shop-white-tekst">
              {{ price.details.initialAmount }}
            </TextBlock>
            <!--            $$t('month')-->
          </div>
        </div>
        <div class="coupon d-flex justify-content-between mb-4">
          <HeraInput
            v-model="couponCode"
            :disabled="couponApplied"
            :label="$t(`_web_checkout_shop-promo-code`, 'Promo code')"
            :placeholder="
              $t(`_web_checkout_shop-enter-promocode`, 'Enter promocode')
            "
            :error="couponError"
            :class="{
              'is-invalid': !!couponError,
            }"
            class="coupon-input shop-grey-tekst"
          />
          <Btn
            class="apply-coupon-button subscription-btn btn-accent d-flex align-items-center h-ml-3 justify-content-center"
            :label="
              couponApplied
                ? $t('_web_shop_applied', 'Applied')
                : $t('_web_shop_applly', 'Apply')
            "
            :loading="isCouponChecking"
            :disabled="!couponCode || couponApplied"
            @click="apply"
          />
        </div>
        <div
          v-if="plan.tax"
          class="subtotal d-flex justify-content-between mb-3"
        >
          <div>
            <TextBlock class="shop-grey-tekst">
              {{ $$t('TAX') }}
            </TextBlock>
          </div>
          <div>
            <TextBlock class="shop-white-tekst">{{
              $$t(plan.currency)
            }}</TextBlock>
            <TextBlock class="shop-white-tekst">
              {{ plan.tax }}
            </TextBlock>
          </div>
        </div>
        <div
          v-if="price.details && price.details.discount"
          class="discount d-flex justify-content-between mb-3"
        >
          <div>
            <TextBlock class="shop-grey-tekst">
              {{ $$t('Discount') }}
            </TextBlock>
          </div>
          <div>
            <TextBlock class="shop-white-tekst">
              {{ price.details.discount }}%
            </TextBlock>
          </div>
        </div>
        <div
          v-if="price.details.couponAmount"
          class="discount d-flex justify-content-between mb-3"
        >
          <div>
            <TextBlock class="shop-grey-tekst">
              {{ $$t('Promo code discount') }}
            </TextBlock>
          </div>
          <div>
            <TextBlock class="shop-white-tekst">{{
              $$t(price.currency)
            }}</TextBlock>
            <TextBlock class="shop-white-tekst">
              {{ price.details.couponAmount.toFixed(2) }}
            </TextBlock>
          </div>
        </div>
        <div class="total d-flex justify-content-between mb-5">
          <div>
            <TextBlock class="shop-grey-tekst">
              {{ $$t('Total') }}
            </TextBlock>
          </div>
          <div class="font-weight-bold">
            <TextBlock class="shop-white-tekst">{{
              $$t(price.currency)
            }}</TextBlock>
            <TextBlock class="shop-white-tekst">
              {{ price.amount.toFixed(2) }}
            </TextBlock>
          </div>
        </div>
      </div>
    </div>
    <div class="payment-user-options" style="gap: 30px">
      <div
        v-if="paymentUserOption === ''"
        class="payment-option-wrapper"
        style="min-height: 260px; margin-bottom: 0px"
      >
        <span class="payment-method" style="color: white">
          {{ $t('_web_subscription_payment-method', 'Payment Method:') }}
        </span>
        <!-- hardcoded false to applepay-->
        <div
          v-if="$flagsmith.flags.payment_apple_pay_enabled.value && false"
          class="payment-option"
          @click="selectPaymentOption('applePay')"
        >
          <div class="option-wrapper">
            <div class="image-pay-wrapper">
              <icon name="ApplePay" :width="24" />
            </div>
            <span>{{
              $t('_web_subscription_payment-method-apple pay', 'Apple Pay')
            }}</span>
          </div>

          <icon
            :class="isRTL ? 'rtl-transform-chevron' : ''"
            name="chevron-right-small"
            :width="24"
          />
        </div>
        <!-- Flagsmith dcb payment-->
        <div
          v-if="$flagsmith.flags.dcb_payment.value"
          class="payment-option"
          @click="selectPaymentOption('mobilePhone')"
        >
          <div class="option-wrapper">
            <div class="image-pay-wrapper">
              <icon name="paywithmobile" :width="24" />
            </div>
            <span>{{
              $t(
                '_web_subscription_payment-method-dcb',
                'Pay with Mobile Phone'
              )
            }}</span>
          </div>

          <icon
            :class="isRTL ? 'rtl-transform-chevron' : ''"
            name="chevron-right-small"
            :width="24"
          />
        </div>
        <div
          class="payment-option"
          @click="selectPaymentOption('creditDebitCard')"
        >
          <div class="option-wrapper">
            <div class="image-pay-wrapper">
              <icon name="cards" :width="24" />
            </div>
            <span>{{
              $t(
                '_web_subscription_payment-method-creditcard',
                'Credit/Debit Card'
              )
            }}</span>
          </div>

          <icon
            :class="isRTL ? 'rtl-transform-chevron' : ''"
            name="chevron-right-small"
            :width="24"
          />
        </div>
      </div>
      <div v-if="paymentUserOption === 'mobilePhone'" class="mobile-payment">
        <div v-if="!transaction">
          <div v-if="!transaction" class="button-wrapper-modal mb-5">
            <div
              v-if="!transaction"
              class="text-payment-method d-flex flex-column"
            >
              <span style="color: rgba(255, 255, 255, 0.8)">{{
                $t(
                  `_web_checkout_shop-provide-information`,
                  'Provide Information'
                )
              }}</span>
            </div>
            <div
              v-if="!transaction"
              class="image-pay-wrapper"
              style="height: unset; width: unset; padding: 7px; cursor: pointer"
              @click="goBackMobile"
            >
              <icon
                name="arrow-left"
                :width="24"
                :style="isRTL ? 'rotate:180deg;' : ''"
              />
            </div>
          </div>

          <span class="verify-label">{{
            $t(`_web_checkout_shop-provider`, 'Provider')
          }}</span>
          <button class="telecom-picker" disabled>
            <icon name="providerPlaceholder" :width="24" />
            {{ providerTelecom }}
          </button>
        </div>
        <InputPhone
          v-if="!transaction"
          v-model="phone"
          name="phone"
          class="mt-5"
          :label="$$t('Mobile Phone (DCB)', 'phone_input_label_dcb')"
        />
        <div v-if="transaction" class="verify-wrapper">
          <div v-if="statusMessage === 'Success'">
            <div class="toast-sucess-payment mb-3">
              {{
                $t(`_web_checkout_shop-payment-succ`, 'Payment is Sucessfull')
              }}
            </div>
          </div>
          <div v-if="transaction" class="button-wrapper-modal mb-5">
            <div
              v-if="transaction"
              class="text-payment-method d-flex flex-column"
            >
              <span style="color: rgba(255, 255, 255, 0.8)">{{
                $t(
                  `_web_checkout_shop-verify-transaction`,
                  'Verify Transaction'
                )
              }}</span>
            </div>
            <div
              v-if="transaction"
              class="image-pay-wrapper"
              style="height: unset; width: unset; padding: 7px; cursor: pointer"
              @click="goBackMobile"
            >
              <icon
                name="arrow-left"
                :width="24"
                :style="isRTL ? 'rotate:180deg;' : ''"
              />
            </div>
          </div>
          <span class="verify-text">{{
            $t(`_web_checkout_shop-pin-code`, 'PIN Code')
          }}</span>
          <InputVerify v-model="code" class="mt-2" tag="form" :count="4" />
          <span
            v-if="statusMessage !== 'Success' && statusMessage.length > 1"
            class="error-message mt-2"
            >{{
              $t(
                `_web_checkout_shop-payment-failed`,
                'Payment failed, check your email'
              )
            }}</span
          >
          <div class="verify-text-wrapper mt-5">
            <span class="verify-text">{{
              $t(`_web_checkout_shop-no-code`, `Haven't received the code?`)
            }}</span>
            <button
              class="verify-text-button"
              :disabled="resendDisabled"
              @click="dcbResend"
            >
              {{
                resendDisabled
                  ? $t(`_web_checkout_shop-resend-in`, `Resend in`) +
                    remainingSeconds
                  : $t(`_web_checkout_shop-resend`, `Resend`)
              }}
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="
          !isProcessing &&
            paymentUserOption === 'creditDebitCard' &&
            paymentOption !== 'new'
        "
        class="payment-option-wrapper custom-scrollbar"
      >
        <div class="button-wrapper-modal">
          <div class="text-payment-method d-flex flex-column">
            <TextBlock
              v-if="fortCards.length"
              :size="0.875"
              class="mb-3"
              style="color: white"
              >{{
                $t(`_web_checkout_shop-choose-payment`, 'Choose payment method')
              }}</TextBlock
            >
            <TextBlock
              v-if="fortCards.length"
              :size="0.75"
              style="
                font-size: 12px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.5);
              "
              >{{
                $t(`_web_checkout_shop-saved-methods`, 'Saved payment methods')
              }}</TextBlock
            >
          </div>
          <div
            v-if="paymentUserOption === 'creditDebitCard'"
            class="image-pay-wrapper"
            style="height: unset; width: unset; padding: 7px; cursor: pointer"
            @click="goBack"
          >
            <icon
              name="arrow-left"
              :width="24"
              :style="isRTL ? 'rotate:180deg;' : ''"
            />
          </div>
        </div>

        <div
          v-if="fortCards.length && !isProcessing"
          class="cards-option-wrapper custom-scrollbar"
          style="max-height: 230px"
        >
          <div
            v-for="(item, index) in fortCards"
            :key="index"
            class="payment-option"
            @click="selectCardFort(item)"
          >
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <img
                  v-if="item.card_type === 'MASTERCARD'"
                  src="@/assets/images/mastercard_payment.png"
                  width="24px"
                />
                <icon v-else :name="item.card_type.toLowerCase()" :width="24" />
              </div>
              <div :style="{ direction: isRTL ? 'ltr' : '' }">
                {{
                  `${item.card_type
                    .charAt(0)
                    .toUpperCase()}${item.card_type
                    .slice(1)
                    .toLowerCase()}${item.card_number.slice(-8)}`
                }}
              </div>
            </div>
            <div class="option-wrapper">
              <div
                v-if="paymentOption.id === item.id"
                class="d-flex cvv-input-container"
              >
                <input
                  id="card_security_code"
                  v-model="cvv"
                  type="text"
                  name="card_security_code"
                  placeholder="CVV"
                  class="input-cvv-field"
                  @input="handleCvvInput"
                />
              </div>
              <input
                v-model="paymentOption"
                type="radio"
                name="paymentOption"
                :value="item"
              />
            </div>
          </div>
          <div class="payment-option" @click="updateAddCard">
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <icon name="credit-card" :width="24" />
              </div>

              <div>
                {{ $t(`_web_checkout_shop-add-new`, 'add new card') }}
              </div>
            </div>
            <icon
              :class="isRTL ? 'rtl-transform-chevron' : ''"
              name="chevron-right-small"
              :width="24"
            />
          </div>
        </div>
      </div>
      <div
        v-if="
          paymentOption === 'new' && paymentUserOption === 'creditDebitCard'
        "
        class="button-wrapper-modal"
      >
        <div class="text-payment-method d-flex flex-column">
          <span style="color: white">{{
            $t(`_web_checkout_shop-payment-information`, 'Payment Information')
          }}</span>
        </div>
        <div
          v-if="fortCards.length"
          class="image-pay-wrapper"
          style="height: unset; width: unset; padding: 7px; cursor: pointer"
          @click="goBack"
        >
          <icon
            name="arrow-left"
            :width="24"
            :style="isRTL ? 'rotate:180deg;' : ''"
          />
        </div>
        <div
          v-else
          class="image-pay-wrapper"
          style="height: unset; width: unset; padding: 7px; cursor: pointer"
          @click="goBackNoCard"
        >
          <icon
            name="arrow-left"
            :width="24"
            :style="isRTL ? 'rotate:180deg;' : ''"
          />
        </div>
      </div>
      <PayFort
        v-if="
          paymentOption === 'new' && paymentUserOption === 'creditDebitCard'
        "
        ref="payFortRef"
        :subscription="plan.id"
        :order="order"
        :is-shop="order ? true : false"
        :coupon="couponCode"
        @paymentProcessing="processing"
        @paymentNotProcessing="processingFalse"
      />
      <p v-if="cvvMessage" class="error-message">{{ cvvMessage }}</p>
      <div
        v-if="paymentUserOption !== 'mobilePhone'"
        class="close-modal-btn-container mt-6"
      >
        <div class="checkbox-spacer">
          <Checkbox v-model="termsState" @change="updatePayButtonState" />
          <label for="termsState" class="terms-label">
            <span class="terms-hover" @click="redirectToTermsPage">
              {{
                $t(
                  `_web_checkout_shop-terms-cond`,
                  'I read and agree to the Terms and conditions.'
                )
              }}
            </span>
          </label>
        </div>
        <Btn
          id="pay-button"
          class="btn-accent d-flex align-items-center justify-content-center w-100"
          icon="shield-check"
          :icon-size="24"
          :label="$t(`_web_checkout_complete-purchase`, 'Complete Purchase')"
          :disabled="isLoading || !agreed || !enablePayButton"
          @click="callPayfortPay"
        />
        <button class="close-modal-btn" @click.prevent="closeModal">
          {{ $t('web_cancel', 'Cancel') }}
        </button>
        <div class="secure-notice">
          <icon
            name="lock-closed"
            :width="24"
            :fill="$scss.colors.secondaryTextBg"
          />
          <TextBlock
            :size="0.875"
            class="mx-3"
            :variant="'muted'"
            style="font-family: Alexandria"
          >
            {{
              $t(
                '_web_your_payment',
                'Your payment data is encrypted and secure.'
              )
            }}
          </TextBlock>
        </div>
      </div>
      <div v-else>
        <Btn
          v-if="!transaction"
          class="btn-accent d-flex align-items-center justify-content-center"
          style="width: 100%"
          :label="$t(`_web_checkout_confirm`, 'Confirm')"
          :disabled="phone.length < 8"
          @click="dcb"
        />
        <div v-if="transaction" class="close-modal-btn-container">
          <div class="checkbox-spacer">
            <Checkbox v-model="termsState" @change="updatePayButtonState" />
            <label for="termsState" class="terms-label">
              {{
                $t(
                  `_web_checkout_shop-terms-cond`,
                  'I have read and agree to the Terms and conditions.'
                )
              }}
            </label>
          </div>
          <Btn
            class="btn-accent d-flex align-items-center justify-content-center"
            icon="shield-check"
            style="width: 100%"
            :label="$t(`_web_checkout_complete-purchase`, 'Complete Purchase')"
            :disabled="code.length !== 4 || isLoading || !enablePayButton"
            @click="dcbPayment"
          />
          <button class="close-modal-btn" @click.prevent="closeModal">
            {{ $t('web_cancel', 'Cancel') }}
          </button>
          <div class="secure-notice">
            <icon
              name="lock-closed"
              :width="24"
              :fill="$scss.colors.secondaryTextBg"
            />
            <TextBlock
              :size="0.875"
              class="mx-3"
              :variant="'muted'"
              style="font-family: Alexandria"
            >
              {{
                $t(
                  '_web_your_payment',
                  'Your payment data is encrypted and secure.'
                )
              }}
            </TextBlock>
          </div>
        </div>
      </div>
    </div>

    <Preloader v-if="isProcessing" :is-loading="isProcessing" has-backdrop />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { translate } from '@/mixins/translate';
import { prop } from '@/utils/factories';

import Btn from '@/components/atoms/HeraFormBtn';
import Checkbox from '@/components/atoms/form/Checkbox.vue';
import flagsmithMixin from '@/mixins/flagsmithMixin';

import TextBlock from '@/components/atoms/TextBlock.vue';
import icon from '@/components/atoms/Icon';
import HeraInput from '@/components/atoms/form/HeraFormTextInput';
import Preloader from '@/components/common/HeraListPreloader';
import PayFort from './billing/PayFort.vue';
import InputPhone from '@/components/form/InputPhoneNew';
import InputVerify from '@/components/form/InputVerify';

export default {
  name: 'CheckoutCard',
  components: {
    Btn,
    Checkbox,
    TextBlock,
    icon,
    HeraInput,
    Preloader,
    PayFort,
    InputPhone,
    InputVerify,
  },
  mixins: [translate('_web_subscription'), flagsmithMixin],
  props: {
    isLoading: prop(Boolean, false),
    error: prop(String, ''),
    plan: prop(Object),
    order: prop(String, ''),
  },
  data() {
    return {
      card: {},
      price: {},
      couponCode: null,
      couponError: '',
      couponApplied: false,
      agreed: true,
      isPriceLoading: false,
      isCouponChecking: false,
      isProcessing: false,
      cvvValid: false,
      cvv: '',
      cvvMessage: '',
      fortCards: [],
      paymentOption: '',
      termsState: false,
      enablePayButton: false,
      paymentUserOption: '',
      phone: '',
      transaction: '',
      code: '',
      statusMessage: '',
      resendDisabled: false,
      countdown: 60,
      countdownInterval: null,
      providerTelecom: 'Zain',
      expireMobile: null,
    };
  },
  computed: {
    ...mapGetters(['currentLocale', 'isRTL']),
    remainingSeconds() {
      return this.countdown + 's';
    },
  },
  watch: {
    statusMessage(newVal) {
      if (newVal === 'Success') {
        setTimeout(() => {
          this.closeModal();
        }, 5000);
      }
    },
    expireMobile(newVal) {
      if (newVal) {
        this.startTimer();
      }
    },
  },
  created() {
    this.getCardsPayfort().then(res => {
      if (res.cards.length) {
        this.fortCards = res.cards;
      } else {
        this.paymentOption = 'new';
      }
    });
  },
  mounted() {
    this.getPrice();
  },
  methods: {
    ...mapActions([
      'checkCoupon',
      'verifyCard',
      'errorNotify',
      'closeModal',
      'getCardsPayfort',
      'saveCardPayfortPaySub',
      'mobileSubPayment',
      'mobileSubCharge',
      'resendCodeDCB',
    ]),

    handleCvvInput(event) {
      this.cvvMessage = '';
      this.cvv = event.target.value.replace(/\D/g, '');
    },

    validateCVV(card_cvv, card_type) {
      this.cvvMessage = this.$t(
        '_web_pay_fort_Invalid-CVV',
        'Invalid Card CVV'
      );
      if (card_cvv.length > 0) {
        card_cvv = card_cvv.trim();

        if (card_cvv.length === 3 && card_cvv !== '000') {
          this.cvvValid = true;
          this.cvvMessage = '';
        } else if (
          card_cvv.length === 4 &&
          card_type === 'amex' &&
          card_cvv !== '0000'
        ) {
          this.cvvValid = true;
          this.cvvMessage = '';
        }
      }
    },
    callPayfortPay() {
      if (this.paymentOption === 'new') {
        this.$refs.payFortRef.tokenization();
      } else {
        Promise.all([
          this.validateCVV(this.cvv, this.paymentOption.card_type),
        ]).then(() => {
          if (this.cvvValid && !this.cvvMessage) {
            this.isProcessing = true;
            this.saveCardPayfortPaySub({
              subscriptionId: this.plan.id,
              card_id: this.paymentOption.id,
              card_security_code: this.cvv,
              coupon: this.couponCode,
            }).then(res => {
              console.log(res);
              if (res.redirectUrl) {
                window.location.href = res.redirectUrl;
              }
            });
          }
        });
      }
    },
    dcb() {
      Promise.all([]).then(() => {
        this.mobileSubPayment({
          subscriptionId: this.plan.id,
          phone: this.phone,
          coupon: this.couponCode,
          provider: this.providerTelecom,
        }).then(res => {
          this.transaction = res.transaction;
          this.expireMobile = res.expires;
        });
      });
    },
    dcbResend() {
      if (this.resendDisabled) {
        return;
      }
      this.startCountdown();
      Promise.all([]).then(() => {
        this.resendCodeDCB({
          transaction: this.transaction,
        }).then(() => {
          this.code = '';
          this.enablePayButton = false;
          this.termsState = false;
        });
      });
    },
    dcbPayment() {
      Promise.all([]).then(() => {
        this.mobileSubCharge({
          transaction: this.transaction,
          code: this.code,
        }).then(res => {
          if (res.status === 'failed') {
            this.statusMessage = res.message;
          } else if (res.status === 'Success') {
            this.statusMessage = 'Success';
          } else {
            this.statusMessage = '';
          }

          this.code = '';
          this.enablePayButton = false;
          this.termsState = false;
        });
      });
    },
    processing() {
      this.isProcessing = true;
    },
    processingFalse() {
      this.isProcessing = false;
    },
    startCountdown() {
      this.resendDisabled = true;
      this.countdown = 60;

      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.resendDisabled = false;
          clearInterval(this.countdownInterval);
        }
      }, 1000);
    },
    getPrice() {
      this.isPriceLoading = true;
      this.checkCoupon({
        subscriptionId: this.plan.id,
      })
        .then(res => {
          this.price = res;
        })
        .catch(error => {
          this.errorNotify(error);
        })
        .finally(() => {
          this.isPriceLoading = false;
        });
    },
    redirectToTermsPage() {
      const baseUrl = '/static/terms/';
      const route = this.isRTL ? 'other' : 'mena';
      const url = `${baseUrl}${route}`;
      window.location.href = url;
    },
    apply() {
      this.isCouponChecking = true;
      this.couponError = '';
      this.checkCoupon({
        subscriptionId: this.plan.id,
        coupon: this.couponCode,
      })
        .then(res => {
          if (res) {
            this.price = res;
            this.couponApplied = true;
          }
        })
        .catch(() => {
          this.couponError = this.$$t('Wrong code');
          this.couponCode = null;
        })
        .finally(() => {
          this.isCouponChecking = false;
        });
    },
    selectPaymentOption(option) {
      this.paymentUserOption = option;
    },
    updatePayButtonState() {
      this.enablePayButton = this.termsState;
    },
    updateAddCard() {
      this.paymentOption = 'new';
    },
    selectCardFort(cardId) {
      this.paymentOption = cardId;
    },
    startTimer() {
      if (this.expireMobile) {
        const currentTime = Math.floor(Date.now() / 1000);
        const remainingTime = this.expireMobile - currentTime;
        if (remainingTime > 0) {
          setTimeout(() => {
            this.paymentUserOption = '';
            this.transaction = '';
            this.phone = '';
          }, remainingTime * 100);
        }
      }
    },
    goBack() {
      if (this.paymentOption === 'new') {
        this.paymentOption = '';
      } else {
        this.paymentUserOption = '';
      }
    },
    goBackNoCard() {
      this.paymentUserOption = '';
    },
    goBackMobile() {
      if (this.transaction.length > 0) {
        this.transaction = '';
        this.phone = '';
      } else {
        this.paymentUserOption = '';
      }
    },
  },
};
</script>

<style lang="scss">
#payment-form {
  #element-container {
    width: 450px;
    border-radius: 20px;
    overflow: hidden;
    padding: 1rem;
    background: white;
  }

  .coupon {
    .wrapper-control {
      width: 300px;
    }
    .apply-coupon-button {
      margin-top: 27px;
      max-height: 40px;
      span {
        color: white !important;
      }
    }
  }

  .apply-coupon-button {
    margin-top: auto;
    display: flex;
    align-items: flex-end;
  }

  .coupon-input {
    padding-right: 10px;
  }

  .btn-accent {
    justify-content: center;
  }

  .coupon-input input {
    background-color: #0a0d11;
    border: 1px solid transparent;
  }

  .coupon-input input:focus {
    border: 1px solid $new-bg-primary;
  }

  #error-handler,
  .server-error {
    color: var(--ph-error);
  }

  &.loading {
    cursor: progress;
  }
}

#payment-form,
#element-container,
.modalbackdrop_container {
  max-height: 91vh;
}

@media (max-width: 515px) {
  #payment-form,
  #element-container,
  .modalbackdrop_container {
    width: 100% !important;
    max-height: unset;
  }
}

.close-modal-btn {
  background-color: rgba(218, 0, 0, 1) !important;
  border: none !important;
  color: $hr-bg-modal-btn !important;
  border-radius: 4px;
  font-weight: 700;
  height: 40px !important;
}

.close-modal-btn-container {
  width: 100%;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  gap: 16px;
  > button {
    font-family: Alexandria;
  }
  > button > span {
    font-family: Alexandria;
  }
  .close-modal-btn {
    width: 100% !important;
  }
  @media (max-width: 515px) {
    gap: 9px;
  }
}

.payment-methods {
  display: flex;
  background: #242938;
  width: 100%;
  width: 390px;
  min-height: 168px;
  max-height: 168px;
  overflow: auto;
  border-radius: 8px;
  margin-top: 14px;
  padding: 24px 16px;
  gap: 10px;
  margin-bottom: -15px;
  max-width: 100%;
  color: #eff0f1;

  .card-inline {
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
  }

  @media (max-width: 515px) {
    width: 100%;
  }
}

.save-card-checkout {
  justify-content: flex-start;
  width: 100% !important;
  gap: 8px;
  padding: 8px;
}

.input-cvv-field {
  background-color: #18181f;
  border: none;
  min-height: 2.5rem;
  border-radius: 5px;
  color: white;
  max-width: 50px;
  text-align: center;
}

.cvv-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
  color: white;
}

.error-message {
  color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
  margin-top: 30px;
}

.apply-coupon-button {
  margin-top: 27px;
  max-height: 40px;
}

.shop-white-tekst {
  color: white !important;
  font-family: Alexandria;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 20px !important;
  letter-spacing: -0.18px;
}

.shop-grey-tekst {
  color: grey;
  font-family: Alexandria;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 20px !important;
  letter-spacing: -0.18px;
}

.form-payment {
  display: flex;
  gap: 32px;

  @media (max-width: 930px) {
    flex-direction: column;
    align-items: center;
  }

  .plan-details-shop {
    max-width: 310px;
    min-width: 300px;
    @media (max-width: 515px) {
      min-width: unset;
    }
    .coupon {
      .coupon-input {
        .wrapper-control-label {
          label {
            color: grey !important;
            font-family: Alexandria !important;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            letter-spacing: -0.18px;
          }

          input {
            background-color: rgba(28, 33, 43, 1) !important;
          }
        }
      }
    }

    .plan-details-shop {
      div > input {
        width: 100% !important;
      }
    }
  }
}

.form-payment {
  @media (max-width: 930px) {
    flex-direction: column;
    align-items: center;
  }

  .plan-details-shop {
    .coupon {
      .coupon-input {
        div > span {
          color: #eb6666;
          font-family: Exo;
          font-size: 14px !important;
          font-weight: 400;
          line-height: 24px !important;
          margin: 0px 5px;
        }

        div > input {
          width: 100% !important;
        }

        .wrapper-control-label {
          label {
            color: grey !important;
          }
        }
      }
    }
  }
}

.divider-payment-sub {
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 32px 0;
}

.payment-option-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.payment-option {
  display: flex;
  height: 64px;
  padding: 16px 16px 16px 8px;
  gap: 12px;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.option-wrapper {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  > span,
  div {
    font-family: Alexandria;
  }
}

.image-pay-wrapper {
  display: flex;
  padding: 11px;
  width: 46px;
  height: 46px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.06);
}

.payment-user-options {
  border-radius: 16px;
  background-color: #1c212b;
  padding: 32px;
  min-width: 460px;
  max-width: 460px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 460px;

  @media (max-width: 530px) {
    min-width: 100%;
    padding: 16px;
    width: 355px;
  }
}

.terms-label,
.payment-method,
.text-payment-method {
  color: grey;
  font-family: Alexandria;
  font-size: 14px;
  font-weight: 500;
}

.cards-option-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 180px;
  overflow: auto;
}

.checkbox-spacer {
  display: flex;
  gap: 12px;
}

.rtl-transform-chevron {
  rotate: 180deg;
}

.terms-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}

.mobile-payment {
  .verify-wrapper {
    .verify-text-button {
      background-color: transparent;
      border: none;
      width: fit-content;
      padding: 0px;
      font-family: Alexandria;
      font-size: 14px;
      font-weight: 500;
      color: rgba(209, 209, 219, 1);
    }

    .verify-text {
      font-family: Alexandria;
      font-size: 14px;
      font-weight: 500;
      color: grey;
    }

    .input-verify {
      min-height: unset !important;
    }
  }

  .form-group {
    label {
      font-family: Alexandria;
      font-size: 14px;
      font-weight: 500;
      color: grey;
    }

    .float-dropbox {
      background-color: rgba(51, 55, 64, 1) !important;

      div > .input-search.focused {
        border-bottom-color: unset;
      }

      .list-loader {
        .list-wrapper {
          div {
            max-height: 150px !important;
          }
        }
      }
    }

    .dropbox-list .list-loader .container {
      min-height: 165px;
    }

    .dropbox-list li > :not(hr):hover {
      background-color: rgba(64, 74, 99, 1) !important;
    }

    .float-dropbox.show.float-dropbox-top::after {
      background-color: rgba(51, 55, 64, 1) !important;
    }

    .input-group-prepend {
      button {
        background-color: rgba(255, 255, 255, 0.05) !important;
        height: 2.15rem;
      }
    }

    .hera-input-phone_input:focus {
      box-shadow: unset !important;
    }

    .new-phone-input {
      border-color: rgba(255, 255, 255, 0.04);
      background-color: unset !important;

      input {
        background-color: rgba(255, 255, 255, 0.05) !important;
      }
    }
  }
}

.verify-text-wrapper {
  display: flex;
  flex-direction: column;
}

.verify-label {
  font-family: Alexandria;
  font-size: 14px;
  font-weight: 500;
  color: grey;
  display: flex;
  align-items: center;
  gap: 6px;
}

.telecom-picker {
  border-radius: 4px;
  width: 100%;
  height: 2.15rem;
  border-color: rgba(255, 255, 255, 0.04);
  background-color: rgba(255, 255, 255, 0.05);
  color: white;
  text-align: left;
}
.button-wrapper-modal {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.secure-notice {
  display: flex;
  justify-content: center;
  align-items: center;
}
.subscription-details {
  .subscription-btn {
    span {
      color: white !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.toast-sucess-payment {
  width: 100%;
  max-width: 100%;
  min-height: 38px;
  padding: 16px;
  border-radius: 8px;
  background: rgb(75, 181, 67);
  color: white;
  border-radius: 8px;
  /* Elevated */
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.07),
    0px 5px 10px 0px rgba(0, 0, 0, 0.05);
}
</style>
